import { Field } from 'Util/Query';

/**
 * Payment Token Query
 * @class PaymentTokenQuery
 */
export class PaymentTokenQuery {
    getPaymentTokensQuery() {
        return new Field('customerPaymentTokens')
            .addFieldList(this._getPaymentTokensFields());
    }

    _getPaymentTokensFields() {
        return [
            'token_id',
            'last_four_digits',
            'expiration_date',
            'card_name',
            'default_token',
            'card_holder_name',
            'card_type',
            'token_expiration',
            'token_status'
        ];
    }

    getSetDefaultTokenMutation(options) {
        const { token_id } = options;
        return new Field('setDefaultCustomerPaymentToken')
            .addArgument('token_id', 'String!', token_id)
            .addFieldList(['success']);
    }

    getDeleteTokenMutation(options) {
        const { token_id } = options;
        return new Field('deleteCustomerPaymentToken')
            .addArgument('token_id', 'String!', token_id)
            .addFieldList(['success']);
    }

    getRenameCustomerPaymentTokenMutation(options) {
        const { token_id, card_name } = options;
        return new Field('renameCustomerPaymentToken')
            .addArgument('token_id', 'String!', token_id)
            .addArgument('card_name', 'String!', card_name)
            .addFieldList(['success']);
    }
}

export default new PaymentTokenQuery();
